import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=2efe7c60"
import script from "../../services/teacher/class-list.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/class-list.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports